import { API_DOMAIN, authHeaders } from '@/api/headers.js';
import { createPayload } from '@/utils/createPayload';
import axios from 'axios';

const EDDE_DE_PROXY_ADDRESS = `${API_DOMAIN}/deproxy`;

export const fetchSiteLocation = async (siteID) => {
    const { token } = await createPayload(null);

    const { data, status } = await axios.get(`${EDDE_DE_PROXY_ADDRESS}/v1/sites/${siteID}/location`, {
        headers: authHeaders(token),
    });
    return { data, status };
};
